module.exports = __webpack_public_path__ + "img/01.8a7a5667.gif";